let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8cVqZ")).then(() => parcelRequire('fXPMK'));